export {VolumeControl} from './volume';



// WEBPACK FOOTER //
// ./components/volume/index.js


// WEBPACK FOOTER //
// ui/components/volume/index.js